import './MobilePage.scss';
import { Box } from '@mui/material';
import { useCallback, useMemo } from 'react';
import Header from './components/Header';
import EslPairingFlow from './components/EslPairingFlow';
import { useLanguage } from './hooks/useLanguage';
import { useMobileState } from './provider/context';
import { MobileProvider } from './provider/Provider';
import { TabKey } from './provider/state';
import { MOBILE_FEATURE_CONFIG, MOBILE_FLOW_TYPE } from './types';
import Tabs from './components/Tabs';
import { BarcodeScannerProvider } from './provider/scanner/BarcodeScannerProvider';
import { CameraScannerProvider } from './provider/camera/CameraScannerProvider';

const MobilePage = () => {
    const { currentLang, handleLanguageChange } = useLanguage();
    // Common
    const { state, dispatch } = useMobileState();
    const { loading, info } = state.storeState;
    const handleTabChange = useCallback(
        (nextTab: TabKey) => {
            dispatch({ type: 'SET_ACTIVE_TAB', payload: nextTab });
        },
        [dispatch],
    );

    const FeatureConfig = useMemo(() => MOBILE_FEATURE_CONFIG[state.activeTab], [state.activeTab]);
    return (
        <>
            <Box
                sx={{
                    height: '100dvh',
                    width: '100vw',
                    pt: '74px',
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                    fontSize: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Header
                    isLoadingStore={loading}
                    storeName={info.store_name || 'store not found'}
                    currentLanguage={currentLang}
                    onLanguageChange={handleLanguageChange}
                />
                <Tabs activeTab={state.activeTab} setActiveTab={handleTabChange} />
                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        overflowY: 'auto',
                    }}
                >
                    {FeatureConfig.type === MOBILE_FLOW_TYPE.ESL_REGISTRATION_FLOW && <FeatureConfig.component />}
                    {FeatureConfig.type === MOBILE_FLOW_TYPE.ESL_PAIRING_FLOW && (
                        <EslPairingFlow FeatureView={FeatureConfig.component} />
                    )}
                </Box>
            </Box>
            {state.isSubmitting && (
                <Box
                    sx={{
                        position: 'fixed',
                        inset: 0,
                        bgcolor: 'rgba(0, 0, 0, 0.35)',
                        zIndex: 2000,
                        pointerEvents: 'auto',
                    }}
                />
            )}
        </>
    );
};

const MobileTestPage = () => {
    return (
        <MobileProvider>
            <BarcodeScannerProvider>
                <CameraScannerProvider>
                    <MobilePage />
                </CameraScannerProvider>
            </BarcodeScannerProvider>
        </MobileProvider>
    );
};

export default MobileTestPage;
